import axios from "axios";
import CONSTANT from '@/services/Constant.js';

export default {
    /*
    * Method to handle stripe payment
    */
    stripeResponseHandler: function(token_from_stripe, callback) { 
        if (token_from_stripe) {
            // token to create a charge on our server

            var request = {
                token: token_from_stripe
            };

            // Send to our server
            axios
            .post(
                CONSTANT.PAY_STRIPE_URL,
                request
            )
            .then(res => {
                var error = res.data.error;
                // var charge = res.data.charge;
                if (error) {
                    callback(false, error);
                } else {
                    callback(true, res);
                }
            });
        } else {
            callback(false, 'Missing stripe token');
        }
    }
}